export default "__VITE_ASSET__SEruvjDL__"